module.exports = __webpack_public_path__ + "static/media/recreation_zone.b5c85cc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/recreation_zone.svg
// module id = 1444
// module chunks = 0